export default __webpack_public_path__ + "static/media/qr-code.6b2bf8c8.svg";